const digest = 'd724bdbe2adc576876071265a97c1b401ec2cdcd2d0c6ecb5f5c0742e4c0d72e';
const css = `._cardTile_9123v_1{background-color:hsla(0,0%,100%,.9);justify-content:center;max-width:25rem}._cardTile_9123v_1 :not(a,a *,button,button *){max-width:100%;word-break:break-word}._image_9123v_11{height:29.65rem;object-fit:cover;width:100%}h4._heading_9123v_17{font-size:1.9rem;line-height:2.2rem}@media screen and (max-width:799px){h4._heading_9123v_17{font-family:BentonSans;font-size:1.25rem;font-weight:400;line-height:1.75rem}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'cardTile': '_cardTile_9123v_1', 'image': '_image_9123v_11', 'heading': '_heading_9123v_17' };
export const cardTile = '_cardTile_9123v_1';
export const image = '_image_9123v_11';
export const heading = '_heading_9123v_17';
export { css, digest };